import { OrderChangesHistory } from '../../../../api/services/orders/types.ts'
import Card from '../../../common/Card/Card.tsx'
import ItemCard, { withDivStyles } from './ItemCard/ItemCard.tsx'

export const StyledItemCard = withDivStyles(
  ItemCard,
  'text-sm border my-2 p-4 bg-white dark:bg-gray-700 rounded shadow-md'
)

const ChangesHistory = ({
  onlyHistory
}: {
  onlyHistory: OrderChangesHistory[]
}) => {
  if (onlyHistory.length === 0) {
    return <p className="p-4 text-center">Brak historii zmian.</p>
  }

  const historySorted = onlyHistory.sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  )
  return (
    <Card className="w-full box-border mt-8 shadow-md">
      <Card.Body>
        {onlyHistory &&
          historySorted.map((item) => (
            <StyledItemCard key={item.created_at} item={item} />
          ))}
      </Card.Body>
    </Card>
  )
}

export default ChangesHistory
